import { useDispatch } from 'react-redux';
import { pipe } from 'ramda';

import { resetErrors, setPassword } from 'store/session/actions';

export const useActions = () => {
  const dispatch = useDispatch();

  return {
    resetPassword: pipe(setPassword, dispatch),
    resetErrors: pipe(resetErrors, dispatch),
  };
};
